var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('f7-button',{class:[_vm.$style.button, ( _obj = {}, _obj[_vm.$style.fade] = _vm.closed, _obj )],attrs:{"fill":"","large":""},on:{"click":_vm.onClick}},[_c('span',[_vm._v(_vm._s(_vm.orderButtonName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }